import api from "./axios";

function message(error, fallback) {
  return error?.response?.data?.message || error?.message || fallback;
}

export const tableReservationsApi = {
  async list(projectId, params = {}) {
    try {
      const { data } = await api.get(`/projects/${projectId}/appointments/table-reservations`, {
        params,
        headers: { "Cache-Control": "no-cache" },
      });
      if (!data?.ok) throw new Error(data?.message || "No se pudieron cargar las reservas gastronómicas.");
      return data.reservations || [];
    } catch (error) {
      throw new Error(message(error, "No se pudieron cargar las reservas gastronómicas."));
    }
  },

  async availability(projectId, params) {
    try {
      const { data } = await api.get(`/projects/${projectId}/appointments/table-reservations/availability`, { params });
      if (!data?.ok) throw new Error(data?.message || "No se pudo consultar la disponibilidad de mesas.");
      return data.availability;
    } catch (error) {
      throw new Error(message(error, "No se pudo consultar la disponibilidad de mesas."));
    }
  },

  async create(projectId, payload) {
    try {
      const { data } = await api.post(`/projects/${projectId}/appointments/table-reservations`, payload);
      if (!data?.ok) throw new Error(data?.message || "No se pudo crear la reserva gastronómica.");
      return data.reservation;
    } catch (error) {
      throw new Error(message(error, "No se pudo crear la reserva gastronómica."));
    }
  },

  async update(projectId, reservationId, payload) {
    try {
      const { data } = await api.put(`/projects/${projectId}/appointments/table-reservations/${reservationId}`, payload);
      if (!data?.ok) throw new Error(data?.message || "No se pudo actualizar la reserva gastronómica.");
      return data.reservation;
    } catch (error) {
      throw new Error(message(error, "No se pudo actualizar la reserva gastronómica."));
    }
  },
};
